import ChatContainer from "@/components/ChatContainer/chatContainer.component";
import React, { useMemo } from "react";

type ChatSingleTagProps = {
  tagID: number;
  additionalTagIDs: number[];
};

const ChatSingleTag: React.FC<ChatSingleTagProps> = ({
  tagID,
  additionalTagIDs,
}) => {
  const allTagIDs = useMemo(() => {
    return [tagID, ...additionalTagIDs]; // Combine the tagID and additionalTagIDs into a single array
  }, [tagID, additionalTagIDs]);

  return (
    <div className="w-full h-full flex flex-col overflow-hidden pt-1 px-2 border rounded">
      <div className="flex justify-between items-center">
        <div className="w-full">
          <h1 className="font-bold text-center text-lg">Chat</h1>
        </div>
      </div>
      {tagID + additionalTagIDs.length > 0 ? (
        <ChatContainer chatID={allTagIDs} type="singleTagChat" />
      ) : (
        <div className="text-left text-xl">
          No tags selected. Please select a tag to view the chat.
        </div>
      )}
    </div>
  );
};

export default ChatSingleTag;
